import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppBusyStateComponentDef } from '@df/ui/display/busy-state/app-busy-state.component.def';

@Component({
    selector: 'app-busy-state',
    templateUrl: './app-busy-state.html',
    standalone: true,
    imports: [CdkPortalOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppBusyStateComponent extends AppBusyStateComponentDef {}
